import { useTranslation } from "react-i18next";
import opportunitiesKeyImage from "src/assets/images/home/unlock-opportunities/opportunities-key.png";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { Link } from "src/components/Link";
import { PATHNAMES } from "src/constants/routes";
import { unlockOpportunitiesTrns } from "./trns";

const OPPORTUNITIES_KEY_IMAGE_ALT_TEXT = "Unlock Opportunities";

export const UnlockOpportunities = () => {
  const { t } = useTranslation();

  return (
    <section className="container flex flex-col justify-between items-center gap-5 py-10 md:flex-row">
      <div className="flex flex-col gap-5 basis-1/2">
        <h3>{t(unlockOpportunitiesTrns.title)}</h3>
        <p className="text-justify">{t(unlockOpportunitiesTrns.description)}</p>
        <Link href={PATHNAMES.OPPORTUNITIES}>
          <Button
            variant={ButtonVariants.PRIMARY}
            className="px-10 text-xl font-medium"
          >
            {t(unlockOpportunitiesTrns.learnMoreButton)}
          </Button>
        </Link>
      </div>

      <div className="max-w-89 lg:max-w-148">
        <img
          className="w-full"
          src={opportunitiesKeyImage}
          alt={OPPORTUNITIES_KEY_IMAGE_ALT_TEXT}
        />
      </div>
    </section>
  );
};
